import { Flex, Text } from '@radix-ui/themes';
import { TbArrowUpRight, TbUser } from 'react-icons/tb';
import { Avatar as AvatarComponent } from '@radix-ui/themes';
import { capitalise } from '~/utils/capitalise';
import { useSession } from '~/features/auth/context/Session';
import { useStore } from '@nanostores/react';
import { workspaceStore } from '~/stores/workspace';
import Styles from './avatar.module.scss';

export function Avatar({
  handleNavigationToAccount,
}: {
  handleNavigationToAccount?: (route: string, search?: Record<string, unknown>) => void;
}) {
  const { session } = useSession();
  const project = useStore(workspaceStore.project);
  const initial = session?.identity?.traits.given_name
    ?.split(' ')
    .map((n: string) => n[0])
    .join('');

  return (
    <Flex align="center" gap="3" mb="1">
      <Flex>
        {session?.identity?.traits.picture ? (
          <AvatarComponent radius="full" fallback={capitalise(initial)} src={session?.identity?.traits.picture} />
        ) : (
          <Flex className={Styles.FallbackAvatar}>
            <TbUser color="var(--cyan-11)" fontSize="2rem" />
          </Flex>
        )}
      </Flex>
      <Flex direction="column" mt="-1">
        <Text>
          {session?.identity?.traits.given_name} {session?.identity?.traits.family_name}
        </Text>

        <Flex
          align="center"
          gap="1"
          role="button"
          tabIndex={0}
          className={Styles.Link}
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              handleNavigationToAccount?.('/account', project?.id ? { backToProjectId: project.id } : undefined);
            }
          }}
          onClick={() =>
            handleNavigationToAccount?.('/account', project?.id ? { backToProjectId: project.id } : undefined)
          }
        >
          <Text size="1" weight="medium">
            View account
          </Text>
          <TbArrowUpRight fontSize="1.2rem" style={{ transform: 'translateY(1px)' }} />
        </Flex>
      </Flex>
    </Flex>
  );
}
